module.exports = __webpack_public_path__ + "img/200401.05044232.png";